<div class="wrapper">
  <div class="projects-content">
    <div class="buttons">
      <a *isRoot routerLink="/root/managers" mat-raised-button>
        <mat-icon color="primary" mat-list-icon>account_box</mat-icon>
        {{ 'MENU.admin_panel' | translate }}
      </a>
      <a *isDev routerLink="/dev" mat-raised-button>
        <mat-icon color="primary" mat-list-icon>developer_board</mat-icon>
        {{ 'MENU.developer' | translate }}
      </a>
      <button mat-raised-button (click)="logout()">
        <mat-icon color="primary" mat-list-icon>exit_to_app</mat-icon>
        {{ 'MENU.exit' | translate }}
      </button>
    </div>

    <app-layout columnCount="12">
      <app-layout-content>
        <app-debts [debts]="debts"></app-debts>
      </app-layout-content>
    </app-layout>

  </div>
</div>
